import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { UserContextInitService } from '../services/user-workpaper-context/user-workpaper-context.service';

@Injectable({ providedIn: 'root' })
export class UserContextResolver implements Resolve<Promise<void>> {
  constructor(private userContextInitService: UserContextInitService) {}

  async resolve(): Promise<void> {
    await this.userContextInitService.setUserPermissionsContext();
    await this.userContextInitService.setPassword();
    //await this.userContextInitService.protectWorkbook();
  }
}